module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-bottom-metals-remnants.fd4de08d.png";